import appConfig from '../config'

const MEMBER_WEB_PROTOCOL = appConfig.MEMBER_WEB_PROTOCOL
const MEMBER_WEB_URL = appConfig.MEMBER_WEB_URL

const openPreview = async (itemPath: string) => {
  const url = `${MEMBER_WEB_PROTOCOL}://${MEMBER_WEB_URL}/${itemPath}`
  // used this opposed to Linking as it is web only and we want it to open a new tab
  window.open(url, '_blank')
}

export default openPreview
